angular.module('rjmNg.services').factory 'dashboardService', [
  "$clientAppUrl"
  "$rootScope"
  "app"
  "enums"
  "$q"
  "$http"
  "$url"
  ($clientAppUrl, $rootScope, app, enums, $q, $http, $url) ->
    dashboardService = {}

    dashboardService.getAddFigureUrl = (row=null, sizeY=null) ->
      if dashboardService.dashboard?
        if row? and sizeY?
          newRow = row + 1 + sizeY
          url = $clientAppUrl("/reports/?dashboardId=#{dashboardService.dashboard.id}&row=#{newRow}")
        else
          url = $clientAppUrl("/reports/?dashboardId=#{dashboardService.dashboard.id}")
      else
        url = $clientAppUrl("/reports")
      return url

    dashboardService.closeChartBuilder = () ->
      $rootScope.$apply ->
        $rootScope.$broadcast('closeChartBuilder')

    dashboardService.openChartBuilder = () ->
      $rootScope.$broadcast('openChartBuilder')

    dashboardService.dashboardItemAdded = (dashboardItem) ->
      $rootScope.$broadcast('dashboardItemAdded', dashboardItem)

    dashboardService.setDashboard = (dashboard) ->
      @dashboard = dashboard
      $rootScope.$broadcast('dashboardReady')

    dashboardService.setWindowTitle = (title) ->
      $rootScope.$broadcast('setWindowTitle', {title: title})

    dashboardService.toggleTouringMode = (touringState) ->
      $rootScope.$broadcast('isTouring', touringState)

    dashboardService.readyForCallToAction = () ->
      $rootScope.$broadcast('readyForCallToAction')

    dashboardService.setTourStep = (dataStep) ->
      $rootScope.$broadcast('tourStep', dataStep)

    dashboardService.beginTourSteps = (tourType) ->
      $rootScope.$broadcast('beginTourSteps', tourType)

    dashboardService.startTourForFirstTime = () ->
      $rootScope.$broadcast('startTourForFirstTime')

    dashboardService.toggleButtonChange = () ->
      $rootScope.$broadcast('toggleButtonChange')

    dashboardService.updateGlobalSearch = () ->
      $rootScope.$broadcast('updateGlobalSearch')

    dashboardService.lockNavBar = () ->
      $rootScope.$broadcast('lockNavBar')

    dashboardService.unlockNavBar = () ->
      $rootScope.$broadcast('unlockNavBar')

    dashboardService.canEditDashboard = () ->
      return @dashboard?.permission is enums.DASHBOARD_PERMISSION.EDIT or @dashboard?.userId is app.getUserId()

    dashboardService.getDashboardOwnerId = () ->
      return @dashboard?.userId

    dashboardService.isSharedDashboard = () ->
      return @dashboard?.is_shared


    dashboardService.getId = () ->
      return @dashboard?.id

    dashboardService.getAvailable = (force=false) ->
      deferred = $q.defer()
      promise = $http
        method: "GET"
        url: $url("/client/#{app.getClientId()}/dashboard/available")
        cache: not force
      .then ({data}) ->
        deferred.resolve(data)
      .catch () ->
        deferred.reject()
      return deferred.promise

    dashboardService.getShareList = () ->
      deferred = $q.defer()
      promise = $http
        method: "GET"
        url: $url("/client/#{app.getClientId()}/dashboard/#{@dashboard.id}/sharing")
      .then ({data}) ->
        deferred.resolve(data)
      .catch () ->
        deferred.reject()
      return deferred.promise

    dashboardService.follow = (dashboard) ->
      deferred = $q.defer()
      userName = dashboard.userName
      $http
        method: 'POST'
        url: $url("/client/#{app.getClientId()}/dashboard/#{dashboard.id}/sharingStatus")
        data:
          status: enums.DASHBOARD_PERMISSION.EDIT # Ask for highest permissions
      .then ({data}) =>
        updatedDashboard = angular.extend data
        updatedDashboard.userName = userName
        updatedDashboard.is_syndicated = true
        updatedDashboard.is_shared = true
        updatedDashboard.permission = updatedDashboard.clientPermission
        app.addDashboard(updatedDashboard)
        dashboardService._broadcastReady()
        deferred.resolve(updatedDashboard)
      .catch () ->
        deferred.reject()
      return deferred.promise

    dashboardService.unfollow = (dashboard) ->
      deferred = $q.defer()
      $http
        method: 'POST'
        url: $url("/client/#{app.getClientId()}/dashboard/#{dashboard.id}/sharingStatus")
        data:
          status: enums.DASHBOARD_PERMISSION.NONE
      .then ({data}) =>
        app.deleteDashboard(dashboard.id)
        dashboardService._broadcastReady()
        deferred.resolve(data)
      .catch () ->
        deferred.reject()
      return deferred.promise

    dashboardService.save = (dashboard) ->
      deferred = $q.defer()
      $http
        method: 'POST'
        url: $url("/client/#{app.getClientId()}/dashboard/#{dashboard.id}")
        data: dashboard
      .then ({data}) =>
        deferred.resolve(data)
      .catch (error) ->
        deferred.reject(error)
      return deferred.promise

    dashboardService._broadcastReady = () ->
      $rootScope.$broadcast 'updateGlobalSearch'
      $rootScope.$broadcast 'dashboardReady'

    dashboardService.extraDashboardFilters = []

    dashboardService
  ]
